import { atom } from 'jotai';

export interface NotificationData {
  autoCloseTimeoutMS?: number;
  heading: string;
  id: string;
  message: string;
  type: 'error' | 'info' | 'success' | 'warning';
}

export const notificationsAtom = atom<NotificationData[]>([]);
